import {
  Card, Button, DialogTitle, Snackbar, DialogActions, Backdrop,
  TableCell, TableContainer, FormControl,
  Table, Checkbox, FormControlLabel, FormLabel, FormGroup, FormHelperText,
  TableRow,
  TableBody,
  TableHead, Typography, ListItemText, ListItemIcon, ListItem, DialogContent, List,
  Dialog, CardContent, CardHeader, Container, Grid, IconButton, TextField, createTheme
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import ListItemButton from '@material-ui/core/ListItemAvatar';
import Divider from '@material-ui/core/Divider';
import FolderIcon from '@material-ui/icons/Folder';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import Alert from 'src/components/Alert';
import AttachFileOutlinedIcon from '@material-ui/icons/AttachFileOutlined';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import Tarihce from 'src/views/History';
import ExtensionIcon from '@material-ui/icons/Extension';
import UploadFile from '../../components/UploadFile';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import { getDate, set } from 'date-fns';
import ExpandableComment from 'src/components/ExpandableComment';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  rootlist: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 550,
  },
  rootlistsag: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 500,
  },

  cardBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  table: {
    minWidth: 650,
  },
  content: {
    minHeight: 550,
  },
  chatSection: {
    width: '100%',
  },
  container: {
    maxHeight: '100%',
    maxWidth: '100%',
    minWidth: '100%'
  },
  container1: {
    maxHeight: 630,
    maxWidth: '100%',
    minWidth: '100%'
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    overflowY: 'auto'
  },
  button: {
    margin: theme.spacing(1),
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0),
    top: theme.spacing(-1),
    color: theme.palette.grey[500],
  },
  formControl: {
    margin: theme.spacing(3)
  },
  cardscontent3: {
    minHeight: 50
  },
  cardscontent2: {
    height: 600
  },
  responsiveContainer: {
    [theme.breakpoints.between("md", "lg")]: {
      maxHeight: "70vh",
      overflowX: 'hidden',
      overflowY: 'scroll'
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: "60vh",
      overflow: 'scroll'
    }
  }
}));

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    },
  },
});
const localeMap = {
  tr: trLocale,
};

const currentDate = new Date()

function CloseConfirm() {
  const classes = useStyles();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [uyariAciklama, setUyariAciklama] = useState('');
  const SessionUser = getUser();
  const [durumId, setDurumId] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [applicationId, setApplicationId] = useState(0);
  const [documentType, setDocumentType] = useState(0);
  const [Required, setRequired] = useState(false);
  const [RequiredIhbarSuresiDolumTarihi, setRequiredIhbarSuresiDolumTarihi] = useState(false);
  const [yorumAciklama, setYorumAciklama] = useState('');
  const [generalData, setGeneralData] = useState([]);
  const [singlePopUp, setSinglePopUp] = useState(false);
  const [filePopUp, setFilePopUp] = useState(false);
  const [fileList, setFileList] = React.useState([])
  const [tarihcePopUp, setTarihcePopUp] = useState(false);
  const [todoData, setTodoData] = useState([]);
  const [selectedWorkOrderId, setSelectedWorkOrderId] = useState([]);
  const [selectedYSOnay, setSelectedYSOnay] = useState([]);
  const [todoPopUp, setTodoPopUp] = useState(false);
  const [checkedMenu, setCheckedMenu] = useState([]);
  const [moyOnayPopUp, setMoyOnayPopUp] = useState(false);
  const [ibraProtokoluPopUp, setibraProtokoluPopUp] = useState(false);
  const [kapanisPopUp, setkapanisPopUp] = useState(false);
  const [moyOnOnayPopUp, setMoyOnOnayPopUp] = useState(false);
  const [closeType, setCloseType] = useState(0);
  const [byOnayPopUp, setBYOnayPopUp] = useState(false);
  const [bySonOnayPopUp, setBYSonOnayPopUp] = useState(false);
  const [moySonOnayPopUp, setmoySonOnayPopUp] = useState(false);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  const [fileTypeData, setFileTypeData] = React.useState([]);
  const [state, setState] = React.useState({
    kural1: false
  });

  const [kapanisTipId, setKapanisTipId] = useState(null)

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const { kural1 } = state;

  const [ihbarnameSuresiDolumTarihi, setIhbarnameSuresiDolumTarihi] = useState(null);
  const [IhbarnameSuresiDolumTarihiVisible, setIhbarnameSuresiDolumTarihiVisible] = useState(false);

  const [tododone, setTodoDone] = useState(0);

  useEffect(() => {
    handleGetCloseApplication(1);
    getApolloTodo();
    const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('id');
    if (myParam) {
      setSelectedIndex(parseInt(myParam));
    }
    let mounted = true;
    return () => {
      mounted = false;
    };
  }, [SessionUser.TopServiceShopCode, SessionUser.TechnicianId]);

  const handleGetCloseApplication = (dataUri) => {
    setLoading(true);
    axios.get(`/GetKapanisBasvuruOnay/${SessionUser.TopServiceShopCode}`)
      .then((response) => {
        setLoading(false);
        const res = response.data;
        setGeneralData(res);
      }).catch(error => {
        setLoading(false);
      });
  }

  const handleReject = () => {
    if ((!yorumAciklama)) {
      setRequired(true);
      return
    }
    const data = [{
      Id: selectedIndex,
      Yorum: yorumAciklama,
      UserId: "", //okta
      Role_Id: 0, //orta katman
      Durum: durumId,
      CloseType: closeType
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetRejectBasvuruClose', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        handleGetCloseApplication(1);
      }
      if (res.ErrorCode === '0') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        setSelectedWorkOrderId([]);
        handleGetCloseApplication(1);
        setSelectedYSOnay([]);
        setState({
          kural1: false,
          kural2: false
        });
      }
    }).catch(error => {
      setLoading(false);
      setSinglePopUp(false);
    });
  }

  const handleBeforeConfirm = () => {
    if ((durumId == 7 && kapanisTipId == 1) || (durumId == 7 && kapanisTipId == 3) ||
      (durumId == 2 && kapanisTipId == 5) || (durumId == 13 && kapanisTipId == 2) || (durumId == 5 && kapanisTipId == 4)) {
      if (checkedMenu.length < todoData.length) {
        setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
        setUyariTip("error");
        setUyari(true);
        return;
      }
      setTodoDone(1);
      setTodoPopUp(false);
    }
  }



  const handleSave = () => {
    if ((durumId == 7 && kapanisTipId == 1) || (durumId == 7 && kapanisTipId == 3) ||
      (durumId == 2 && kapanisTipId == 5) || (durumId == 13 && kapanisTipId == 2) || (durumId == 5 && kapanisTipId == 4)) {
      if (tododone == 0) {
        setresponseMessage('Lütfen gerekli adımları tamamlayıp tekrardan deneyiniz!...')
        setUyariTip("error");
        setUyari(true);
        setTodoPopUp(true);
        return;
      }
    }
    if ((durumId == 22 && kural1 == false) && kapanisTipId == 1) {
      setresponseMessage("Lütfen BY Onay Aksiyonlarını tamamlayınız!...")
      setUyariTip("error");
      setUyari(true);
      handleFileType(selectedIndex);
      setDocumentType(100);
      setBYOnayPopUp(true);
      return;
    }
    if ((durumId == 14 && kural1 == false) && kapanisTipId == 1) {
      setresponseMessage("Lütfen aksiyonları tamamlayınız!...")
      setUyariTip("error");
      setUyari(true);
      handleFileType(selectedIndex);
      setibraProtokoluPopUp(true);
      return;
    } if ((durumId == 10 && kural1 == false) && kapanisTipId == 2) {
      setresponseMessage("Lütfen aksiyonları tamamlayınız!...")
      setUyariTip("error");
      setUyari(true);
      handleFileType(selectedIndex);
      setBYSonOnayPopUp(true);
      return;
    }
    var handleError = false;
    if (!yorumAciklama) {
      setRequired(true);
      setSinglePopUp(true);
      handleError = true;
    }
    if ((!ihbarnameSuresiDolumTarihi && IhbarnameSuresiDolumTarihiVisible) || (!ihbarnameSuresiDolumTarihi && moment(ihbarnameSuresiDolumTarihi, 'dd.MM.yyyy').isValid())) {
      setRequiredIhbarSuresiDolumTarihi(true);
      handleError = true;
    }
    if (handleError) {
      return;
    }
    const data = [{
      Id: selectedIndex,
      Yorum: yorumAciklama,
      UserId: "",
      Role_Id: 0,
      Durum: durumId,
      CloseType: closeType,
      IhbarnameSuresiDolumTarihi: ihbarnameSuresiDolumTarihi
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetApolloServisKapanisOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        setTodoDone(0);
      }
      if (res.ErrorCode === '0') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        setRequired(false);
        handleGetCloseApplication(1);
        setSelectedWorkOrderId([]);
        setSelectedYSOnay([]);
        setTodoPopUp(false);
        setTodoDone(0);
        setState({
          kural1: false,
          kural2: false
        });
      }
    }).catch(error => {
      setLoading(false);
      setSinglePopUp(false);
    });
  }

  const handleActionPopUp = (row) => {
    if ((row.DURUM_ID == 7 && row.KAPANIS_TIP_ID == 1) ||
      (row.DURUM_ID == 13 && row.KAPANIS_TIP_ID == 2) ||
      (row.DURUM_ID == 7 && row.KAPANIS_TIP_ID == 3) ||
      (row.DURUM_ID == 5 && row.KAPANIS_TIP_ID == 4) ||
      (row.DURUM_ID == 2 && row.KAPANIS_TIP_ID == 5) ||
      (row.DURUM_ID == 7 && row.KAPANIS_TIP_ID == 3)) {
      setSelectedIndex(row.ID);
      setTodoPopUp(true);
      setDurumId(row.DURUM_ID);
      getApolloTodo();
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.DURUM_ID == 22 && row.KAPANIS_TIP_ID == 1) ||
      (row.DURUM_ID == 22 && row.KAPANIS_TIP_ID == 5) ||
      (row.DURUM_ID == 2 && row.KAPANIS_TIP_ID == 2)) {
      setSelectedIndex(row.ID);
      setBYOnayPopUp(true);
      setDocumentType(100)
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 6) ||
      (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 22) ||
      (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 6) ||
      (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 6)) {
      setSelectedIndex(row.ID);
      setMoyOnayPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 14) ||
      (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 14) ||
      (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 14) ||
      (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 20)
    ) {
      setSelectedIndex(row.ID);
      setibraProtokoluPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 24) || (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 24) ||
      (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 24) || (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 24)) {
      setSelectedIndex(row.ID);
      setkapanisPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 5)) {
      setSelectedIndex(row.ID);
      setMoyOnOnayPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 10)) {
      setSelectedIndex(row.ID);
      setBYSonOnayPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 18)) {
      setSelectedIndex(row.ID);
      setmoySonOnayPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    // if (row.DURUM_ID == 5) {
    //   setSelectedIndex(row.ID);
    //   handleFileType(row.ID);
    //   setMoyOnOnayPopUp(true);
    //   setDurumId(row.DURUM_ID);
    //   setCloseType(row.KAPANIS_TIP_ID)
    // }
    // else if (row.DURUM_ID == 10) {
    //   setSelectedIndex(row.ID);
    //   setMoyOnayPopUp(true);
    //   handleFileType(row.ID);
    //   setDurumId(row.DURUM_ID);
    //   setCloseType(row.KAPANIS_TIP_ID)
    // }
  }

  const handleSinglePopUp = (row) => {
    //Ihbarname Süresi Dolum Tarihi çıkması için
    row.DURUM_ID == 22 && row.KAPANIS_TIP_ID == 3 ? setIhbarnameSuresiDolumTarihiVisible(true) : setIhbarnameSuresiDolumTarihiVisible(false);

    //SAP AÇILMA İŞLEMİ YORUMLARI
    //Şube kapanıyor ise
    if (row.DURUM_ID == 5 && row.KAPANIS_TIP_ID == 4) {
      //Şube kapanıyor ise ve kapanan şube bilgisi varsa
      if (row.KAPATILAN_SUBELER != "-") {
        setYorumAciklama(`${row.BOLGE}'ye bağlı ${row.SERVIS_KOD} kodlu ${row.SERVIS_AD} servisinin ve kendisine bağlı ${row.KAPATILAN_SUBELER} 'nin mali açıdan uygun olduğunda SAP’de kapatılması için yardımınızı rica ederiz.`);
      }
      //Şube kapanıyor ise ve kapanan şube bilgisi yoksa
      else {
        setYorumAciklama(`${row.BOLGE}'ye bağlı ${row.SERVIS_KOD} kodlu ${row.SERVIS_AD} 'nin mali açıdan uygun olduğunda SAP’de kapatılması için yardımınızı rica ederiz.`);
      }
      setSelectedIndex(row.ID);
      setSinglePopUp(true);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID);
    }
    //Şube kapanışı dışındaki durumlar için(DURUM_IDLER KONTROL EDİLECEK)
    else if ((row.DURUM_ID == 7 && row.KAPANIS_TIP_ID == 1) ||
      (row.DURUM_ID == 13 && row.KAPANIS_TIP_ID == 2) ||
      (row.DURUM_ID == 7 && row.KAPANIS_TIP_ID == 3) ||
      (row.DURUM_ID == 6 && row.KAPANIS_TIP_ID == 5)) {
      if (row.KAPATILAN_SUBELER != "-") {
        setYorumAciklama(`${row.BOLGE}'ye bağlı ${row.SERVIS_KOD} kodlu ${row.SERVIS_AD} servisinin ve kendisine bağlı ${row.KAPATILAN_SUBELER} 'nin mali açıdan uygun olduğunda SAP’de kapatılması için yardımınızı rica ederiz.`);
      }
      //Şube kapanıyor ise ve kapanan şube bilgisi yoksa
      else {
        setYorumAciklama(`${row.BOLGE}'ye bağlı ${row.SERVIS_KOD} kodlu ${row.SERVIS_AD} servisinin mali açıdan uygun olduğunda SAP’de kapatılması için yardımınızı rica ederiz.`);
      }
      setSelectedIndex(row.ID);
      setSinglePopUp(true);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID);
    }


    else {
      setSelectedIndex(row.ID);
      setSinglePopUp(true);
      setYorumAciklama('');
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
  }


  const handleFilePopUp = (row) => {
    setSelectedIndex(row.ID);
    getReceiptAllFiles(row.ID)
    setFilePopUp(true);
  }

  const handleYorum = (row) => {
    setSelectedIndex(row.ID);
    setTarihcePopUp(true);
  }

  const getReceiptAllFiles = (receiptNumber) => {
    setFileList([]);
    setLoading(true);
    if (!receiptNumber) {
      return;
    }
    var images = []
    axios.get("/getReceiptAllFiles/" + receiptNumber + '/' + 2, {
      responseType: 'arrayBuffer'
    }).then(response => {
      setFileList(response.data)
      setLoading(false)
    });
  }

  const getApolloTodo = () => {
    setLoading(true)
    axios.get("/GetApolloTodoList/2").then((response) => {
      const Todo = response.data;
      if (Todo.length === 0) {
        setTodoData([]);
        setLoading(false);
      } else {
        setTodoData(Todo);
        setLoading(false);
      }
    });
  }

  const getMoyOnayText = (row) => {
    setLoading(true)
    axios.get("/GetMOYOnayText/" + row.ID).then((response) => {
      const text = response.data;
      if (text.length === 0) {
        setYorumAciklama('');
        setLoading(false);
      } else {
        setLoading(false);
        setYorumAciklama(text);
        setSelectedIndex(row.ID);
        setSinglePopUp(true);
        setDurumId(row.DURUM_ID);
        setCloseType(row.KAPANIS_TIP_ID)
      }
    });
  }

  const setCheckMenuItem = (id) => {
    if (checkedMenu?.includes(id)) {
      var checkedMenuControl = checkedMenu?.filter((item) => item !== id);
      setCheckedMenu(checkedMenuControl);
    }
    else {
      setCheckedMenu([...checkedMenu, id]);
    }
  }

  const setNewWindowOpen = (item) => {
    //get file data from GetReceiptFilesSpecial api
    setLoading(true);
    axios.get(`/GetReceiptFilesSpecial/${item.DOSYA_ID}`)
      .then((response) => {
        const res = response.data[0];
        var FileData = `data:${res.DOSYA_TIPI};base64,${res.DOSYA_DATA}`
        if (res?.DOSYA_TIPI?.includes('image')) {
          var image = new Image();
          image.src = FileData;
          var w = window.open("");
          w.document.write(image.outerHTML);
          w.document.title = res.DOSYA_ADI;
          w.document.close();
        } else {
          var blobData = base64ToBlob(res.DOSYA_DATA, "application/pdf");
          openBlobInNewTab(blobData);
        }
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });

    // var FileData = `data:${item.DOSYA_TIPI};base64,${item.DOSYA_DATA}`
    // if (item?.DOSYA_TIPI?.includes('image')) {
    //   var image = new Image();
    //   image.src = FileData;
    //   var w = window.open("");
    //   w.document.write(image.outerHTML);
    //   w.document.title = item.DOSYA_ADI;
    //   w.document.close();
    // } else {
    //   var blobData = base64ToBlob(item.DOSYA_DATA, "application/pdf");
    //   openBlobInNewTab(blobData);
    // }
  }

  function base64ToBlob(base64Data, contentType) {
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
  function openBlobInNewTab(blobData) {
    var newTab = window.open();
    var objectUrl = URL.createObjectURL(blobData);
    newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleSaveTodoList = (itemValue) => {
    if (checkedMenu.length < todoData.length) {
      setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
      setUyariTip("error");
      setUyari(true);
      return;
    }
    const data = {
      ApplicationId: selectedIndex,
      Confirm: true,
      UserId: "", //okta
      OpenCloseType: 2
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetTodoOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setTodoPopUp(false);

      }
      if (res.ErrorCode === 0) {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setTodoPopUp(false);
        handleGetCloseApplication(1);
        checkedMenu([]);
      }
    }).catch(error => {
      setLoading(false);
      setTodoPopUp(false);
    });
  }
  const handleFileType = (basvuruId) => {
    axios.get(`/GetFileTypeByIdForClosing/` + basvuruId, {
      responseType: 'arrayBuffer'
    })
      .then((response) => {
        const res = response.data;
        setFileTypeData(res);
      }).catch(error => {
      });
  }




  return (
    <Page className={classes.root}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}>
        </Alert>
      </Snackbar>
      <Container className={classes.container1} maxWidth="xl">
        <Card >
          <CardHeader title="Onay Bekleyenler" />
          <Divider />
          <CardContent >
            <TableContainer >
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Kapanış tipi</TableCell>
                    <TableCell align="left">Son Onay Veren</TableCell>
                    <TableCell align="left">Onay Beklenen</TableCell>
                    <TableCell align="left">Bolge</TableCell>
                    <TableCell align="left">İl-İlçe</TableCell>
                    <TableCell align="left">ServisTipi</TableCell>
                    <TableCell align="left">Servis Bilgi</TableCell>
                    <TableCell align="left">Servis</TableCell>
                    <TableCell align="left">Şube Kodu</TableCell>
                    <TableCell align="left">Şube Merkezi</TableCell>
                    <TableCell align="left">Yorumlar</TableCell>
                    <TableCell align="left">Belgeler</TableCell>
                    <TableCell align="left">Aksiyon</TableCell>
                    <TableCell align="left">Onay/Red</TableCell>
                    <TableCell align="left" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {generalData?.length > 0 && generalData.map((row, index) => (
                    <TableRow key={index}
                      style={row.ID === selectedIndex ? { backgroundColor: "#FF9800" }
                        : {}}
                    >
                      <TableCell align="left">{row.KAPANIS_TIP}</TableCell>
                      <TableCell align="left">{row.DURUM}</TableCell>
                      <TableCell align="left">{row.SONRAKI_ADIM_ACIKLAMA}</TableCell>
                      <TableCell align="left">{row.BOLGE}</TableCell>
                      <TableCell align="left">{row.IL_ILCE}</TableCell>
                      <TableCell align="left">{row.SERVIS_TIPI}</TableCell>
                      <TableCell align="left">
                        <ExpandableComment
                          Comment={row.SERVIS_BILGI}
                          CommentLimit={100}
                          DarkColor={selectedIndex != row.ID ? false : true} />
                      </TableCell>
                      <TableCell align="left">{row.SERVIS}</TableCell>
                      <TableCell align="left">{row.KAPATILAN_SUBELER}</TableCell>
                      {row.KAPANIS_TIP_ID == 4 ?
                        <TableCell align="left">{row.MERKEZ}</TableCell>
                        : <TableCell align="left" />}
                      <TableCell align="left">
                        <IconButton
                          size="small"
                          onClick={() => handleYorum(row)}
                          style={{ backgroundColor: '#19ecff', color: 'white' }}
                        >
                          <CommentOutlinedIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="left">
                        <IconButton
                          size="small"
                          onClick={() => handleFilePopUp(row)}
                          style={{ backgroundColor: '#FF7F00', color: 'white' }}
                        >
                          <AttachFileOutlinedIcon />
                        </IconButton>
                      </TableCell>
                      {(row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 22) ||
                        (row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 6) ||
                        (row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 7) ||
                        (row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 14) ||
                        (row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 24) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 2) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 10) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 5) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 6) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 18) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 13) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 20) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 24) ||
                        (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 22) ||
                        (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 7) ||
                        (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 14) ||
                        (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 24) ||
                        (row.KAPANIS_TIP_ID == 4 && row.DURUM_ID == 5) ||
                        (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 6) ||
                        (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 14) ||
                        (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 24) ||
                        (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 2) ||
                        (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 22)
                        //  && row.ACILIS_TIP_ID != 5 
                        ?
                        <TableCell align="left">
                          <IconButton
                            size="small"
                            onClick={() => {
                              handleActionPopUp(row)
                              setKapanisTipId(row.KAPANIS_TIP_ID)
                              setState({
                                kural1: false
                              });
                            }}
                            style={{ backgroundColor: '#FF4F00', color: 'white' }}
                          >
                            <ExtensionIcon />
                          </IconButton>
                        </TableCell>
                        : <TableCell align="left" />
                      }
                      <TableCell align="left">
                        <IconButton
                          size="small"
                          onClick={() => {
                            setKapanisTipId(row.KAPANIS_TIP_ID)
                            handleSinglePopUp(row)
                          }
                          }
                          style={{ backgroundColor: '#32CD32', color: 'white' }}
                        >
                          <DoneAllIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
          <Dialog
            open={singlePopUp}
            fullWidth
            maxWidth="sm"
            onClose={() => setSinglePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
              {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="sm" spacing={1}>
              <IconButton
                onClick={() => {
                  setSinglePopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'Onayla & Reddet'} />
                <Divider />
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={1}>
                    {IhbarnameSuresiDolumTarihiVisible && <Grid item xs={12} sm={12} lg={12}>
                      <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                          <KeyboardDatePicker
                            color="primary"
                            inputVariant="outlined"
                            label={'İhbarname Süresi Dolum Tarihi'}
                            invalidDateMessage={'Hatalı Tarih Formatı'}
                            format={'dd.MM.yyyy'}
                            minDate={currentDate}
                            error={moment(ihbarnameSuresiDolumTarihi, 'dd.MM.yyyy').isValid() ? false : RequiredIhbarSuresiDolumTarihi}
                            value={ihbarnameSuresiDolumTarihi}
                            variant="outlined"
                            onChange={
                              (date) => {
                                setIhbarnameSuresiDolumTarihi(date)
                              }
                            }
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            fullWidth
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Grid>}
                    <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        size="small"
                        id="desc"
                        autoComplete="no"
                        multiline
                        error={yorumAciklama?.length > 0 ? false : Required}
                        rows={10}
                        value={yorumAciklama}
                        onChange={(event) => setYorumAciklama(
                          event.target.value
                        )}
                        fullWidth
                        label='Yorum'
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              <Divider />
            </Container>
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => handleReject()}
                aria-label="close"
                component="span"
                variant="contained"
                endIcon={<BlockIcon />}
                style={{ backgroundColor: '#ff0000', color: 'white' }}
              >
                Reddet
              </Button>
              <Button
                color="secondary"
                onClick={() => handleSave()}
                aria-label="save"
                component="span"
                variant="contained"
                style={{ backgroundColor: '#008000', color: 'white' }}
                endIcon={<CheckCircleOutlineIcon />}
              >
                Onayla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={filePopUp}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="md"
          >
            <DialogContent>
              <Grid container spacing={2}>
                <List>
                  {fileList?.length ? fileList?.map((item, index) => (
                    <ListItem key={item.DOSYA_ID}>

                      <ListItemButton
                        style={{ display: 'flex', cursor: 'pointer' }}
                      >
                        <ListItemIcon>
                          <FolderIcon style={{ color: '#424242' }} />
                        </ListItemIcon>
                        <ListItemText
                          primary={<Typography type="body2" > {item.DOSYA_ADI}</Typography>}
                          onClick={() => {
                            setNewWindowOpen(item);
                            // setShowFile(true)
                            // setSelectedFile(row)
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  )) : !loading ? "Dosya Bulunmamaktadır." : "Dosyalar Yükleniyor..."}
                </List>

              </Grid>
            </DialogContent>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={() => {
                  setFilePopUp(false);
                }}
                aria-label="close"
                component="span"
                variant="contained"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Dialog>
          <Dialog
            open={tarihcePopUp}
            fullWidth
            maxWidth="lg"
            onClose={event => setTarihcePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Yorum Geçmişi</DialogTitle>
            <DialogContent>
              <Tarihce BasvuruId={selectedIndex} readonly={false} OpenClose={2} />
            </DialogContent>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={event => setTarihcePopUp(false)}
                aria-label="upload picture"
                component="span"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Dialog>
          <Dialog
            open={todoPopUp}
            fullWidth
            maxWidth="sm"
            onClose={() => setTodoPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
              {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="sm" spacing={1}>
              <IconButton
                onClick={() => {
                  setTodoPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'Yapılması Gereken Adımlar'}
                  subheader={<Typography variant="caption" display="block">
                    Adımları tamamlamadan devam edemezsiniz!
                    <br />
                  </Typography>} />
                <Divider />
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <TableContainer>
                        <Table size="small" aria-label="a dense table">
                          <TableBody>
                            {

                              todoData?.map((item) => (
                                <TableRow>
                                  <TableCell align="left" style={{ width: '50px' }}>
                                    <FormControlLabel
                                      value="top"
                                      control={(
                                        <Checkbox
                                          color="primary"
                                          checked={checkedMenu.includes(item?.ID) ? true : false}
                                          onChange={() => setCheckMenuItem(item?.ID)}
                                        />
                                      )}
                                    />
                                  </TableCell>
                                  <TableCell align="left">
                                    {item.ACIKLAMA}
                                  </TableCell>
                                </TableRow>
                              ))
                            }
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              <Divider />
            </Container>
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => setTodoPopUp(false)}
                aria-label="close"
                component="span"
                variant="contained"
                endIcon={<BlockIcon />}
                style={{ backgroundColor: '#ff0000', color: 'white' }}
              >
                KAPAT
              </Button>
              <Button
                color="secondary"
                onClick={() => handleBeforeConfirm()}
                aria-label="save"
                component="span"
                variant="contained"
                style={{ backgroundColor: '#008000', color: 'white' }}
                endIcon={<CheckCircleOutlineIcon />}
              >
                Onayla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={moyOnOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setMoyOnOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
              {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="xl" spacing={1}>
              <IconButton
                onClick={() => {
                  setMoyOnOnayPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'MOY On Onay Adımları'} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <Card className={classes.cards}>
                        <CardContent className={classes.cardscontent2}>
                          <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1}
                            documentTypeNumber={6} openClose={2} />
                          <Divider />
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </CardContent>
                <Button
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '20px 45px 15px 0px'
                  }}
                  color="secondary"
                  onClick={() => setMoyOnOnayPopUp(false)}
                >
                  Tamam
                </Button>
              </Card>
            </Container>
          </Dialog>
          <Dialog
            open={moyOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setMoyOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
              {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="xl" spacing={1}>
              <IconButton
                onClick={() => {
                  setMoyOnayPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'MOY Onay Adımları'} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <Card className={classes.cards}>
                        <CardContent className={classes.cardscontent2}>
                          <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1}
                            documentTypeNumber={27} openClose={2} />
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </CardContent>
                <Button
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '20px 45px 15px 0px'
                  }}
                  color="secondary"
                  onClick={() => setMoyOnayPopUp(false)}
                >
                  TAMAM
                </Button>
              </Card>
              <Divider />
            </Container>
          </Dialog>
          <Dialog
            open={byOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setBYOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
            {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="xl" spacing={1}>
              <IconButton
                onClick={() => {
                  setBYOnayPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'BY Onay Aksiyonlar'} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    {closeType == 1 || closeType == 5 ?
                      <Grid item xs={6} sm={6}>
                        <CardContent className={classes.cardscontent3}>
                          <FormControl component="fieldset" className={classes.formControl}>
                            <FormLabel component="legend">
                              Servis Kapanış süreci için aşağıdaki adımları tamamladınız mı?
                            </FormLabel>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox checked={kural1} onChange={handleChange} name="kural1" />
                                }
                                label="Fesih Protokolü MOY’a ulaştırılmak üzere kargoya verildi mi?"
                              />
                            </FormGroup>
                            <FormHelperText>
                              İşlemleri tamamlamadan devam edemezsiniz!!
                            </FormHelperText>
                          </FormControl>
                        </CardContent>
                      </Grid>
                      : null}
                    {closeType != 1 ?
                      <Grid item xs={12} sm={12}>
                        <CardContent className={classes.cardscontent2}>
                          <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1} documentTypeNumber={documentType}
                            openClose={2} />
                        </CardContent>
                      </Grid>
                      : null}
                  </Grid>
                </CardContent>
                <Button
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '20px 45px 15px 0px'
                  }}
                  color="secondary"
                  onClick={() => setBYOnayPopUp(false)}
                >
                  Tamam
                </Button>
              </Card>
              <Divider />
            </Container>
          </Dialog>
          <Dialog
            open={ibraProtokoluPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setibraProtokoluPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
              {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="xl" spacing={1}>
              <IconButton
                onClick={() => {
                  setibraProtokoluPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'BY İbra Protokolü Adımları'} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    {closeType == 1 || closeType == 2 || closeType == 3 || closeType == 5 ?
                      <Grid item xs={6} sm={6}>
                        <CardContent className={classes.cardscontent3}>
                          <FormControl component="fieldset" className={classes.formControl}>
                            <FormLabel component="legend">
                              Servis Kapanış süreci için aşağıdaki adımları tamamladınız mı?
                            </FormLabel>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox checked={kural1} onChange={handleChange} name="kural1" />
                                }
                                label="İbra Protokolü MOY’a ulaştırılmak üzere kargoya verildi mi? ?"
                              />
                            </FormGroup>
                            <FormHelperText>
                              İşlemleri tamamlamadan devam edemezsiniz!!
                            </FormHelperText>
                          </FormControl>
                        </CardContent>
                      </Grid>
                      : null}
                    <Grid item xs={12} sm={12}>
                      <Card className={classes.cards}>
                        <CardContent className={classes.cardscontent2}>
                          <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1}
                            documentTypeNumber={28} openClose={2} />
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </CardContent>
                <Button
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '20px 45px 15px 0px'
                  }}
                  color="secondary"
                  onClick={() => setibraProtokoluPopUp(false)}
                >
                  TAMAM
                </Button>
              </Card>
              <Divider />
            </Container>
          </Dialog>
          <Dialog
            open={kapanisPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setkapanisPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
              {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="xl" spacing={1}>
              <IconButton
                onClick={() => {
                  setkapanisPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'MOY Servis Kapanis Finali'} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <Card className={classes.cards}>
                        <CardContent className={classes.cardscontent2}>
                          <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1}
                            documentTypeNumber={29} openClose={2} />
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </CardContent>
                <Button
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '20px 45px 15px 0px'
                  }}
                  color="secondary"
                  onClick={() => setkapanisPopUp(false)}
                >
                  TAMAM
                </Button>
              </Card>
              <Divider />
            </Container>
          </Dialog>
          <Dialog
            open={bySonOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setBYSonOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
            {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="xl" spacing={1}>
              <IconButton
                onClick={() => {
                  setBYSonOnayPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'BY Son Onay Aksiyonlar'} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    {closeType == 2 ?
                      <Grid item xs={6} sm={6}>
                        <CardContent className={classes.cardscontent3}>
                          <FormControl component="fieldset" className={classes.formControl}>
                            <FormLabel component="legend">
                              Servis Kapanış süreci için aşağıdaki adımları tamamladınız mı?
                            </FormLabel>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox checked={kural1} onChange={handleChange} name="kural1" />
                                }
                                label="Fesih Protokolü MOY’a ulaştırılmak üzere kargoya verildi mi?"
                              />
                            </FormGroup>
                            <FormHelperText>
                              İşlemleri tamamlamadan devam edemezsiniz!!
                            </FormHelperText>
                          </FormControl>
                        </CardContent>
                      </Grid>
                      : null}
                    {closeType != 2 ?
                      <Grid item xs={12} sm={12}>
                        <CardContent className={classes.cardscontent2}>
                          <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1} documentTypeNumber={7}
                            openClose={2} />
                        </CardContent>
                      </Grid>
                      : null}
                  </Grid>
                </CardContent>
                <Button
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '20px 45px 15px 0px'
                  }}
                  color="secondary"
                  onClick={() => setBYSonOnayPopUp(false)}
                >
                  Tamam
                </Button>
              </Card>
              <Divider />
            </Container>
          </Dialog>
          <Dialog
            open={moySonOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setmoySonOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              {/* {' '}
            {consumerInformation[0]?.ContactName} */}
            </DialogTitle>
            <Container maxWidth="xl" spacing={1}>
              <IconButton
                onClick={() => {
                  setmoySonOnayPopUp(false);
                }}
                aria-label="close"
                className={classes.closeButton}
                component="span"
                variant="contained"
                edge="start"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
              <Divider />
              <Card>
                <CardHeader title={'MOY Son Onay Aksiyonlar'} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <CardContent className={classes.cardscontent2}>
                        <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1}
                          documentTypeNumber={8}
                          openClose={2} />
                      </CardContent>
                    </Grid>
                  </Grid>
                </CardContent>
                <Button
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '20px 45px 15px 0px'
                  }}
                  color="secondary"
                  onClick={() => setmoySonOnayPopUp(false)}
                >
                  Tamam
                </Button>
              </Card>
              <Divider />
            </Container>
          </Dialog>
          <Divider />
        </Card>
      </Container>
    </Page >
  );
}

export default CloseConfirm;
